module.exports = __webpack_public_path__ + "static/img/15.0c1ea9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/15.jpg
// module id = dPf4
// module chunks = 0